<template>
  <v-container>
    <v-form ref="form" v-model="validado">
      <v-row dense>
        <!-- Botón de regreso -->
        <v-col cols="6">
          <v-btn icon @click="$router.go(-1)">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-col>
        <v-col class="btn-final" cols="6">
          <!-- <v-btn class="cancel" @click="Cancelar"> Cancelar </v-btn> -->
          <save-btn
            class="btn-oval"
            :record-status="costo.estatus"
            :loading="loading"
            @click="guardarYContinuar"
          />
        </v-col>
        <v-col cols="12" md="12">
          <div class="text-h6">Costos por actividad y por lugar</div>
        </v-col>

        <!--    <v-col cols="6" md="6">
          <form-meta
            :data="costo"
            :remove-commit="'removerCosto'"
            :record-id="costo.id"
            @removed="$router.go(-1)"
          />
        </v-col> -->

        <v-col cols="12" md="12">
          <div class="font-weight-medium blue--text">
            Los campos con * son importantes
          </div>
        </v-col>

        <!-- Fila: Actividad y Fecha -->
        <v-col cols="6" md="6">
          <v-select
            v-model="costo.actividad"
            :items="productionModules"
            label="Actividad *"
            :rules="[r.required]"
            outlined
            dense
            name="estado"
            @input="debounceBuscarRegistroExistente"
          />
        </v-col>

        <!-- Fila: Finca, Parcela y Ciclo -->
        <v-col cols="6" md="6">
          <v-select
            v-model="costo.id_finca"
            :no-data-text="$vuetify.noDataText"
            :items="fincas"
            item-text="nombre"
            item-value="id"
            label="Finca *"
            :rules="[r.required]"
            outlined
            dense
            @input="debounceBuscarRegistroExistente"
          >
            <template slot="item" slot-scope="{ item }">
              <finca-select-item :item="item" />
            </template>
          </v-select>
        </v-col>
        <v-col cols="6" md="6">
          <v-text-field
            v-model="costo.fecha"
            label="Fecha Inicio de esta Producción *"
            :rules="[r.required]"
            dense
            outlined
            placeholder="aaaa/mm/dd"
            @change="validarFecha"
            @input="debounceBuscarRegistroExistente"
          />
          <p v-if="errorin" style="color: red">{{ errorin }}</p>
        </v-col>
        <!-- Aqui esta en campo de fecha con el calendario-->
        <!-- <v-col cols="6" md="6">
          <v-text-field
            type="date"
            v-model="costo.fecha"
            label="Fecha Inicio de esta Producción *"
            :rules="[r.required]"
            dense
            outlined
            @input="debounceBuscarRegistroExistente"
          />
        </v-col> -->
        <v-col cols="6" md="6">
          <v-select
            v-model="costo.id_parcela"
            :no-data-text="$vuetify.noDataText"
            clearable
            outlined
            dense
            :items="parcelasPorId(costo.id_finca)"
            item-value="id"
            item-text="nombre"
            label="Lote, Parcela, Estanque, Galera"
            @input="debounceBuscarRegistroExistente"
          />
        </v-col>

        <v-col cols="4" md="4">
          <v-select
            v-model="costo.ciclo"
            :items="ciclo"
            outlined
            dense
            :rules="[r.required]"
            clearable
            name="ciclo"
            label="Ciclo *"
            @input="debounceBuscarRegistroExistente"
          />
        </v-col>
        <!-- Fila: Tabla de costos -->
        <v-col cols="12" class="table-responsive">
          <table>
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Actividad o Producto</th>
                <th>Descripción</th>
                <th>Cantidad</th>
                <th>Unidad</th>
                <th>Costo Total</th>
                <th>Rubro o Especie</th>
                <th>Identificador de Trazabilidad</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(gasto, index) in costo.producciones || []"
                :key="`producciones-${index}`"
              >
                <td>
                  <div style="min-width: 100px">
                    <v-text-field
                      v-model="gasto.fecha_trx"
                      :rules="[r.required]"
                      dense
                      outlined
                      placeholder="aaaa-mm-dd"
                      @change="validarFechaf"
                    />
                    <p v-if="errorinf" style="color: red">{{ errorinf }}</p>
                  </div>
                </td>
                <td>
                  <v-select
                    v-model="gasto.producto"
                    :items="tipo_producto"
                    item-text="producto"
                    item-value="producto"
                    outlined
                    :rules="[r.required]"
                    dense
                    @click="onProductoChange(index)"
                  />
                </td>
                <td>
                  <v-text-field
                    v-model="gasto.describa"
                    item-text="describa"
                    item-value="describa"
                    outlined
                    dense
                  />
                </td>
                <td>
                  <v-text-field
                    type="number"
                    v-model="gasto.cantidad"
                    dense
                    outlined
                  />
                </td>
                <td>
                  <v-select
                    v-model="gasto.unidad"
                    :items="unidad_medida"
                    item-text="descripcion"
                    item-value="id"
                    outlined
                    dense
                    name="unidad"
                  />
                </td>
                <td>
                  <v-text-field
                    type="text"
                    v-model="gasto.precio_total"
                    dense
                    outlined
                  />
                </td>
                <td>
                  <v-select
                    v-model="gasto.cultivo"
                    :items="rubros"
                    item-text="descripcion"
                    item-value="id"
                    outlined
                    clearable
                    dense
                    name="rubro"
                  />
                </td>
                <td>
                  <v-text-field v-model="gasto.identirubro" dense outlined />
                </td>
                <td class="delete">
                  <v-btn icon @click="borrarItem(index)" style="color: red">
                    <v-icon>mdi-alpha-x-circle</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </v-col>

        <v-col cols="12">
          <v-btn
            depressed
            block
            class="primary--text custom-button"
            @click="addRow"
          >
            <v-icon left>mdi-plus</v-icon>
            Agrega Costo
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <registro-existente
      :title="'La producción ya existe'"
      :description="'Los datos colocados corresponden a una producción existente, desea cargar la información de esta producción?'"
      :loading="modal_registro_existe_loading"
      :modal="modal_registro_existe"
      @cerrarModal="cerrarModalRegistroExistente"
      @cargarDatos="cargarRegistroExistente"
    />
  </v-container>
</template>

<script>
import * as rules from '@/utils/validations'
import uuid from 'uuid/v4'
import Form from '@/components/js/Form'
import { mapState, mapGetters } from 'vuex'
import { clona } from '../../utilidades'
import { costo, formulario_costo } from '../../modelos'
import FincaSelectItem from '../../components/FincaSelectItem.vue'
import ModalParcela from '../../components/ModalParcela.vue'
import ModalEstablecimiento from '../../components/ModalEstablecimiento.vue'
import SituacionDeDesastre from '../../components/form/SituacionDeDesastre.vue'
import { productionModules, ciclo } from '@/utils/enums'

export default {
  name: 'Costo',
  components: {
    FincaSelectItem,
    ModalParcela,
    ModalEstablecimiento,
    SituacionDeDesastre,
  },
  extends: Form,
  data() {
    return {
      errorin: '',
      errorinf: '',
      r: rules,
      tabla_principal_id: 'id',
      tabla_produccion_id_rubro: 'id',
      ruta_registros: 'costos',
      ruta_registro: 'costo',
      nombre_registros_en_state: 'costos',
      nombre_registro_en_state: 'costo',
      dispatch_get_registro: 'getCosto',
      dispatch_guardar_registro: 'guardarCosto',
      costo: clona(formulario_costo),
      registro_produccion: clona(costo),
      productionModules,
      ciclo,
    }
  },

  computed: {
    ...mapGetters('registros', [
      'establecimientosPorId',
      'parcelasPorId',
      'getMatchingRecords',
    ]),
    ...mapState('listados', [
      'sexo',
      'tipo_familiar',
      'sino',
      'organizacion',
      'institucion',
      'especie_acuicola',
      'rubro_apicola',
      'rubro_forestal',
      'actividad_pecuaria',
      'actividad_avicola',
      'especie_pesca',
      'unidad_medida',
      'tipo_producto',
      'cultivo',
      'destino',
    ]),
    rubros() {
      switch (this.costo.actividad) {
        case 'AGRICOLA':
          return this.cultivo
        case 'AVICOLA':
          return this.actividad_avicola
        case 'ACUICULTURA':
          return this.especie_acuicola
        case 'APICULTURA':
          return this.rubro_apicola
        case 'FORESTAL':
          return this.rubro_forestal
        case 'PECUARIO':
          return this.actividad_pecuaria
        case 'PESCA':
          return this.especie_pesca
        default:
          return []
      }
    },
  },
  watch: {
    '$route.params.id'() {
      this.cargarRegistro(this.obtenerIdDeRuta())
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Costo')
    const id = this.obtenerIdDeRuta()
    if (id) {
      this.cargarRegistro(id)
    } else {
      this.costo = clona(formulario_costo)
    }

    // Forzar coincidencia de tipo
    if (!this.costo.ciclo) {
      this.costo.ciclo = 1
    } else {
      this.costo.ciclo = Number(this.costo.ciclo)
    }

    this.costo.modulo = this.costo.modulo
  },

  methods: {
    validarFecha(valor) {
      let regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/
      if (!regexFecha.test(valor)) {
        this.errorin =
          'Favor colocar año, mes y día separado con guiones así: aaaa-mm-dd'
        return
      }
      let [, anio, mes, dia] = valor.match(regexFecha)
      if (parseInt(mes) < 1 || parseInt(mes) > 12) {
        this.errorin = 'El mes debe estar en el rango de 1 a 12.'
        return
      }
      let diasEnMes = new Date(anio, mes, 0).getDate()
      if (parseInt(dia) < 1 || parseInt(dia) > diasEnMes) {
        this.errorin = 'El día no es válido para el mes especificado.'
        return
      }
      this.errorin = ''
    },
    validarFechaf(valor) {
      let regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/
      if (!regexFecha.test(valor)) {
        this.errorinf =
          'Favor colocar año, mes y día separado con guiones así: aaaa-mm-dd'
        return
      }
      let [, anio, mes, dia] = valor.match(regexFecha)
      if (parseInt(mes) < 1 || parseInt(mes) > 12) {
        this.errorinf = 'El mes debe estar en el rango de 1 a 12.'
        return
      }
      let diasEnMes = new Date(anio, mes, 0).getDate()
      if (parseInt(dia) < 1 || parseInt(dia) > diasEnMes) {
        this.errorinf = 'El día no es válido para el mes especificado.'
        return
      }
      this.errorinf = ''
    },
    // Método para cargar los primeros valores al iniciar
    borrarItem(index) {
      this.costo.producciones.splice(index, 1)
    },
    checkAddRow(index) {
      // Si el índice actual es el último, agrega una nueva fila
      if (index === this.costo.producciones.length - 1) {
        this.addRow()
      }
    },

    addRow() {
      const newRow = clona(this.registro_produccion)
      newRow.id = uuid() // Asegúrate de generar un ID único aquí
      this.costo.producciones.push(newRow)
    },

    //No se Usa
    async obtenerUnRegistroONada() {
      try {
        const id_productor = this.costo.id_productor
        const actividad = this.costo.actividad
        const ciclo = this.costo.ciclo
        const fecha = this.costo.fecha
        const id_finca = this.costo.id_finca
        const id_parcela = this.costo.id_parcela

        const id_rubros = !this.obtenerIdDeRuta()
          ? this.costo.producciones
              .filter((prod) => !!prod.productor)
              .map((prod) => prod.productor)
          : []
        //  rubros:variabale, se vuelve true o false
        const rubros =
          (!this.obtenerIdDeRuta() && id_rubros.length > 0) ||
          this.obtenerIdDeRuta()

        // required fields to be fulfilled
        if (id_productor && actividad && ciclo && fecha && id_finca) {
          const { status, data } = await this.$store.dispatch(
            'registros/buscaCostos',
            {
              id_productor,
              actividad,
              ciclo,
              fecha,
              id_finca,
              id_parcela,
            }
          )
          if (status === 'ok' && data.length > 0) return data[0]
        }
        return {}
      } catch (e) {
        return {}
      }
    },
    onProductoChange(indice) {
      this.costo.producciones[indice].fecha_inicio = this.costo.fecha
      this.costo.producciones[indice].actividad = this.costo.actividad
      this.costo.producciones[indice].ciclo = this.costo.ciclo
      this.costo.producciones[indice].id_parcela = this.costo.id_parcela
      this.costo.producciones[indice].id_finca = this.costo.id_finca
      this.costo.producciones[indice].estatus = 'A'
    },

    async guardarYContinuar() {
      try {
        this.loading = true
        if (!this.$refs.form.validate()) {
          this.$store.commit('ui/setSnack', {
            text: 'Verifique los elementos en rojo',
            color: 'error',
          })
          return ''
        }

        if (!this.obtenerIdDeRuta()) {
          this.costo.id = uuid()
          this.costo.created_at = new Date()
            .toISOString()
            .slice(0, 19)
            .replace('T', ' ')
        }
        this.costo.updated_at = new Date()
          .toISOString()
          .slice(0, 19)
          .replace('T', ' ')

        // Asegúrate de que los valores de costo son los correctos
        /*    const datosParaGuardar = {
          ...this.costo, // Usar spread operator para asegurarse de tener los valores reales
          producciones: this.costo.producciones.map((prod) => ({
            ...prod, // Asegurarse de que producciones también tenga los valores correctos
            fecha_trx: prod.fecha_trx,
            producto: prod.producto,
            cantidad: prod.cantidad,
            unidad: prod.unidad,
            precio_total: Number(prod.precio_total) || 0,
            cultivo: prod.cultivo,
            identirubro: prod.identirubro,
          })),
        }*/
        const datosParaGuardar = {
          ...this.costo,
          producciones: this.costo.producciones.map((prod) => ({
            ...prod,
            fecha_trx: prod.fecha_trx,
            producto: prod.producto,
            cantidad: prod.cantidad,
            unidad: prod.unidad,
            precio_total: Number(prod.precio_total) || 0,
            cultivo: prod.cultivo,
            identirubro: prod.identirubro,
            // Asignar campos del encabezado
            id_finca: this.costo.id_finca,
            id_parcela: this.costo.id_parcela,
            actividad: this.costo.actividad,
            ciclo: this.costo.ciclo,
            fecha_inicio: this.costo.fecha,
            estatus: 'A',
          })),
        }
        await this.$store.dispatch('registros/guardarCosto', datosParaGuardar)
        this.$router.push('/ru/costos')
      } catch (error) {
        this.$sentry.captureException(error)
        console.error('Error al guardar y continuar:', error)
      } finally {
        this.loading = false
      }
    },
    Cancelar() {
      this.$router.push('/ru/costos')
    },
    obtenerIdDeRuta() {
      return this.$route.params.id || ''
    },
    cargarRegistro(id) {
      if (this.existeRegistroEnState('costos', id)) {
        this.costo = this.obtenerRegistroDelState(id)
        return true
      } else return false
    },
    obtenerRegistroDelState(id) {
      return {
        ...formulario_costo,
        ...this.$store.state.registros.costos[id],
      }
    },
  },
}
</script>
<style scoped>
table {
  width: 150%;
  border-collapse: none;
  margin-top: 20px;
}

th,
td {
  padding: 2px;
  border: none;
}

th {
  background-color: #00a8b7;
  color: white;
  font-weight: bold;
  text-align: center;
  border: 1px solid #ccc; /* Línea divisoria de color gris claro */
}

td {
  text-align: center;
}

tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

tbody tr:hover {
  background-color: #f1f1f1;
}

td {
  color: #333;
  font-size: 14px;
}

.delete {
  width: 30px;
  position: relative;
  background-color: transparent;
}

.table-responsive {
  overflow-x: auto;
}
.button-row td {
  border: none;
  /* Elimina los bordes */
  padding: 0;
  /* Ajusta el padding */
  text-align: center;
  /* Centra el contenido */
}

.button-row {
  margin: 16px 0;
  /* Agrega espacio alrededor */
}
.btn-oval {
  border-radius: 50px; /* Hace que el botón sea más ovalado */
}
.btn-final {
  display: flex;
}
.cancel {
  background-color: red !important;
  color: white !important;
}
</style>
